import clsx from "clsx";
import { ReactNode } from "react";

import Tooltip from "../Tooltip";

interface LabelProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  toolTipText?: string;
}

export function Label({
  className,
  children,
  required,
  toolTipText,
  disabled,
}: LabelProps) {
  return (
    <div className="flex items-center gap-2">
      <label
        className={clsx(
          "block text-xs lg:text-sm font-medium whitespace-nowrap",
          disabled ? "text-gray-400" : "text-gray-900",
          className,
        )}
      >
        {children}
        {required && (
          <span className="ml-1 text-red-500" aria-hidden="true">
            *
          </span>
        )}
      </label>
      {toolTipText && <Tooltip text={toolTipText} position="right" />}
    </div>
  );
}
